<template>
  <div class="summer-camp-page">
    <SummerCampHero @schedule="handleSchedule" />
    <SummerCampWhyChoose />
    <SummerCampAboutProgram />
    <SummerCampSchedule />
    <SummerCampLocation />
  </div>
</template>

<script>
import bus from 'common/bus';
import SummerCampHero from '~/components/web/summerCamp/SummerCampHero.vue';
import SummerCampWhyChoose from '~/components/web/summerCamp/SummerCampWhyChoose.vue';
import SummerCampAboutProgram from '~/components/web/summerCamp/SummerCampAboutProgram.vue';
import SummerCampSchedule from '~/components/web/summerCamp/SummerCampSchedule.vue';
import SummerCampLocation from '~/components/web/summerCamp/SummerCampLocation.vue';

export default {
  name: 'SummerCampPage',
  layout: 'noFooterTopLayout',
  components: {
    SummerCampHero,
    SummerCampWhyChoose,
    SummerCampAboutProgram,
    SummerCampSchedule,
    SummerCampLocation,
  },
  computed: {
    locale() {
      return this.$store.state.locale;
    },
    userInfo() {
      return (this.$store.state.ucenter && this.$store.state.ucenter.userInfo) || {};
    },
    selectedLocation() {
      return (this.$store.state.bookingFlow && this.$store.state.bookingFlow.selectedLocation) || null;
    },
  },
  methods: {
    handleSchedule(site) {
      const btnName = 'Schedule a Tour Today';
      try {
        if (this.Sensors) this.Sensors.track(`offline_header_${this.locale}_evaluation`);
      } catch (error) {
        console.warn('Error tracking event:', error);
      }
      if (this.locale === 'bmus') {
        this.$store.commit('bookingFlow/SET_BOOKING_SOURCE', {
          componentId: '',
          componentName: 'summerCampPage',
          btnName,
          originPage: typeof window !== 'undefined' ? window.location.href : '',
          buttonSite: site,
        });
      }
      this.requestUserLocationPermission();
      if (this.selectedLocation && this.selectedLocation.venueId) {
        this.$router.push({
          path: '/book-trial',
          query: {
            locId: this.selectedLocation.venueId,
            locName: this.selectedLocation.name,
          },
        });
        return;
      }
      bus.$emit('openLocationDrawer', {
        componentId: '',
        componentName: 'summerCampPage',
        btnName,
        originPage: typeof window !== 'undefined' ? window.location.href : '',
      });
    },
    requestUserLocationPermission() {
      if (typeof navigator === 'undefined' || !navigator.geolocation) return;
      navigator.geolocation.getCurrentPosition(
        (position) => {
          try {
            sessionStorage.setItem('currentLocationLat', String(position.coords.latitude));
            sessionStorage.setItem('currentLocationLng', String(position.coords.longitude));
          } catch (e) { /* ignore */ }
          bus.$emit('locationPermissionGranted', {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          });
        },
        (err) => {
          console.warn('[SummerCampPage] geolocation error:', err && err.code, err && err.message);
        },
        { timeout: 10000, maximumAge: 0 },
      );
    },
  },
  head() {
    return {
      title: 'Summer Camp - Think Academy',
    };
  },
};
</script>

<style lang="scss" scoped>
.summer-camp-page {
  width: 100%;
  font-family: 'Roboto-Flex', sans-serif;
  background: #fff;
  color: #44454c;
}
</style>
